import { loadStripe } from '@stripe/stripe-js';

const STRIPE_PUBLIC_KEY = process.env.REACT_APP_STRIPE_PUBLIC_KEY;
if (!STRIPE_PUBLIC_KEY) throw new Error('STRIPE_PUBLIC_KEY is not defined');
const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

export default stripePromise;
